"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvVarConfigName = void 0;
var EnvVarConfigName;
(function (EnvVarConfigName) {
    EnvVarConfigName["VEHICLE_ID"] = "IOTHUB_DEVICE";
    EnvVarConfigName["IOTHUB_HOSTNAME"] = "IOTHUB_HOST_NAME";
    EnvVarConfigName["IOTHUB_KEY"] = "IOTHUB_KEY";
    EnvVarConfigName["STATIC_IP_AUTO"] = "STATIC_IP_AUTO";
    EnvVarConfigName["ENVIRONMENT"] = "AIRSTREAM_ENV";
    EnvVarConfigName["COMPONENT_CONFIG"] = "TRAILER_COMPONENT_CONFIG";
    EnvVarConfigName["CAN_CHANNEL"] = "CAN_CHANNEL";
})(EnvVarConfigName = exports.EnvVarConfigName || (exports.EnvVarConfigName = {}));
//# sourceMappingURL=EnvVarConfigName.js.map